(function($) {
    $(function () {
        var selectSearch = $('#tag-search');

        let postType = selectSearch.data('list-type');

        selectSearch.select2({
            dropdownAutoWidth: true,
            minimumInputLength: 0,
            multiple: false,
            placeholder: "Tags",
            allowClear: true,
            sorter: function(data) {
    return data.sort(function(a, b) {
        return a.text.toLowerCase() < b.text.toLowerCase() ? -1 : a.text.toLowerCase() > b.text.toLowerCase() ? 1 : 0;
    });
}
            /*ajax: {
                url: drturner_params.ajax_url,
                data: function (params) {
                    return {
                        q: params.term,
                        action: 'get_tag_list',
                        postType
                    };
                },
                processResults: function (resp) {
                    let results = [];
                    if(resp.success) {
                        results = resp.data;
                    }

                    return {
                        results
                    };
                }
            }*/
        });

        selectSearch.on('select2:select', function (e) {
            var {data} = e.params;
            let input = $('input[name="tag_search_label"]');
            // console.log(data);
            input.val(data.text);
        });
    });
})(jQuery);
